import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Form,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  Row,
  InputGroup,
} from 'react-bootstrap';

import LayoutContext from '../../../../../store/Layout/contexts';
import { GET, newFetch } from '../../../../../helpers/fetch';
import { config } from '../../../../../config/index';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const { API_URL } = config;

const EditSite = ({ match: { params } }) => {
  const token = localStorage.getItem('token');
  const { client_id, site_id } = params;

  const [client, setClient] = useState({});
  const [site, setSite] = useState({});
  const [defaultShifts, setDefaultShifts] = useState([]);
  const [validated, setValidated] = useState(false);

  const fetchClient = async () => {
    const url = `${API_URL}/client/${client_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let clientData = data.data;

        setClient(clientData);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchSite = async () => {
    const url = `${API_URL}/client/${client_id}/site/${site_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let siteData = data.data;

        setSite(siteData);
        setName(siteData.name);
        setManagerName(siteData.manager_name);
        setManagerEmail(siteData.manager_email);
        setManagerPhoneNo(siteData.manager_phone_no);
        setAttendanceThreshold(siteData.attendance_threshold);
        setFillThreshold(siteData.fill_threshold);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const fetchDefaultShifts = async () => {
    const url = `${API_URL}/site/${site_id}/shifts`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let shiftsData = data.data;

        setDefaultShifts(shiftsData);
        setEditedShifts(JSON.parse(JSON.stringify(shiftsData)));
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const [name, setName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [managerEmail, setManagerEmail] = useState('');
  const [managerPhoneNo, setManagerPhoneNo] = useState('');
  const [attendanceThreshold, setAttendanceThreshold] = useState('');
  const [fillThreshold, setFillThreshold] = useState('');
  const [attendanceInvalid, setAttendanceInvalid] = useState(false);
  const [fillInvalid, setFillInvalid] = useState(false);

  const [editedShifts, setEditedShifts] = useState([]);
  const [newShifts, setNewShifts] = useState([]);

  const nameHandler = (e) => setName(e.target.value);
  const managerNameHandler = (e) => setManagerName(e.target.value);
  const managerEmailHandler = (e) => setManagerEmail(e.target.value);
  const managerPhoneNoHandler = (e) => setManagerPhoneNo(e.target.value);
  const attendanceThresholdHandler = (e) => {
    const value = e.target.value;
    setAttendanceThreshold(value);
    setAttendanceInvalid(!isValidThreshold(value));
  };

  const fillThresholdHandler = (e) => {
    const value = e.target.value;
    setFillThreshold(value);
    setFillInvalid(!isValidThreshold(value));
  };

  const addShifts = () =>
    setNewShifts([
      ...newShifts,
      {
        name: '',
        start_time: '',
        end_time: '',
      },
    ]);

  const removeShift = (index) =>
    setNewShifts([...newShifts].filter((shift, i) => i !== index));

  const editedShiftNameHandler = (e, index) => {
    const newArr = JSON.parse(JSON.stringify(editedShifts));
    newArr[index].name = e.target.value;

    setEditedShifts(newArr);
  };

  const isValidThreshold = (value) => {
    const num = Number(value);
    return value !== '' && !isNaN(num) && num >= 0 && num <= 100;
  };

  // const editedShiftStartTimeHandler = (e, index) => {
  //     const newArr = [...editedShifts]
  //     newArr[index].start_time = e.target.value

  //     setEditedShifts(newArr)
  // }

  // const editedShiftEndTimeHandler = (e, index) => {
  //     const newArr = [...editedShifts]
  //     newArr[index].end_time = e.target.value

  //     setEditedShifts(newArr)
  // }

  const newShiftNameHandler = (e, index) => {
    const newArr = [...newShifts];
    newArr[index].name = e.target.value;
    setNewShifts(newArr);
  };

  const newShiftStartTimeHandler = (e, index) => {
    const newArr = [...newShifts];
    newArr[index].start_time = e.target.value;

    setNewShifts(newArr);
  };

  const newShiftEndTimeHandler = (e, index) => {
    const newArr = [...newShifts];
    newArr[index].end_time = e.target.value;

    setNewShifts(newArr);
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setName(site.name);
      setManagerName(site.manager_name);
      setManagerEmail(site.manager_email);
      setManagerPhoneNo(site.manager_phone_no);
      setAttendanceThreshold(site.attendance_threshold);
      setFillThreshold(site.fill_threshold);
      setEditedShifts(defaultShifts);
      setNewShifts([]);
      setMarkerState({
        longitude: site.lng,
        latitude: site.lat,
      });
      setViewState({
        longitude: site.lng,
        latitude: site.lat,
        zoom: 14,
      });
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  const deactivateSiteHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to deactivate this Site?'
      )
    ) {
      const url = `${API_URL}/client/${client_id}/site/${site_id}`;

      try {
        let response = await fetch(url, {
          method: 'PUT',
          body: JSON.stringify({ active: 0 }),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response) {
          ToastUtil.success('Site deactivated successfully.');
          window.location.replace(
            `${window.location.origin}/clients/client/${client_id}`
          );
        } else {
          ToastUtil.error('Failed to deactivate site.');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const submitSite = async () => {
    const url = `${API_URL}/client/${client_id}/site/${site_id}`;

    const data = {
      name,
      manager_name: managerName,
      manager_email: managerEmail,
      manager_phone_no: managerPhoneNo,
      attendance_threshold: attendanceThreshold,
      fill_threshold: fillThreshold,
      active: true,
    };

    try {
      return await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const submitShifts = async () => {
    // update shifts
    let response_arr = [];

    if (editedShifts.length > 0) {
      const update_url = `${API_URL}/shifts/`;

      await Promise.all(
        editedShifts.map(async (shift) => {
          let data = {
            name: shift.name,
            start_time: shift.start_time,
            end_time: shift.end_time,
          };

          try {
            let response = await fetch(update_url + shift.id, {
              method: 'PUT',
              body: JSON.stringify(data),
              withCredentials: true,
              mode: 'cors',
              headers: {
                Authorization: token,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json; charset=utf-8',
              },
            });

            let response_data = await response.json();

            response_arr.push(response_data);
          } catch (error) {
            console.log(error);
          }
        })
      );
    }

    // add new shifts
    if (newShifts.length > 0) {
      const create_url = `${API_URL}/site/${site_id}/shifts`;

      await Promise.all(
        newShifts.map(async (shift) => {
          let data = {
            name: shift.name,
            start_time: shift.start_time,
            end_time: shift.end_time,
          };

          try {
            let response = await fetch(create_url, {
              method: 'POST',
              body: JSON.stringify(data),
              withCredentials: true,
              mode: 'cors',
              headers: {
                Authorization: token,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json; charset=utf-8',
              },
            });

            let response_data = await response.json();

            response_arr.push(response_data);
          } catch (error) {
            console.log(error);
          }
        })
      );
    }

    return response_arr;
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    let msg = 'Are you sure you want to update this Site?';

    msg = !site.active
      ? `Editing deactivated sites will reactivate the site. ${msg}`
      : msg;

    if (await AlertService.confirm('', msg)) {
      let response_shifts = await submitShifts();

      // let shiftResponseData = await response_shifts.json()

      let shiftErr = response_shifts.find((res) => !res.success);

      if (shiftErr) {
        ToastUtil.error(`Shift Error: ${shiftErr.message}`);
      } else {
        let response_site = await submitSite();

        let siteResponseData = await response_site.json();

        if (siteResponseData.success) {
          ToastUtil.success(siteResponseData.message);
          window.location.replace(
            `${window.location.origin}/clients/client/${client_id}/sites/site/${site_id}`
          );
        } else {
          ToastUtil.error(siteResponseData.message);
        }
      }
    }
  };

  useEffect(() => {
    fetchClient();
    fetchSite();
    fetchDefaultShifts();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/clients/client/${client_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i> {client.name}
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit Site</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Site Information</strong>
                <p className="pt-2 text-muted">Manage site's information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <strong>Site Name*</strong>
                    <input
                      required
                      type="text"
                      className="form-control mt-3"
                      value={name}
                      maxLength={255}
                      onChange={(e) => nameHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter site name.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Name</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={managerName}
                      maxLength={200}
                      onChange={(e) => managerNameHandler(e)}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Email</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={managerEmail}
                      maxLength={200}
                      onChange={(e) => managerEmailHandler(e)}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Contact No</strong>
                    <input
                      type="text"
                      className="form-control mt-3"
                      value={managerPhoneNo || ''}
                      maxLength={25}
                      onChange={(e) => managerPhoneNoHandler(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Threshold</strong>
                <p className="pt-2 text-muted">
                  Manage attendance rate and fill rate threshold
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row ">
                  <div className="col-sm-12">
                    <strong>Attendance rate threshold</strong>
                    <input
                      required
                      name="attendanceThreshold"
                      type="number"
                      min={0}
                      max={100}
                      step="any"
                      placeholder="Attendance rate threshold %"
                      className={`form-control mt-3 ${
                        attendanceInvalid ? 'is-invalid' : ''
                      }`}
                      value={attendanceThreshold}
                      onChange={attendanceThresholdHandler}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a value between 0 and 100.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-12">
                    <strong>Fill rate threshold</strong>
                    <input
                      required
                      name="fillThreshold"
                      type="number"
                      min={0}
                      max={100}
                      step="any"
                      placeholder="Fill rate threshold %"
                      className={`form-control mt-3 ${
                        fillInvalid ? 'is-invalid' : ''
                      }`}
                      value={fillThreshold}
                      onChange={fillThresholdHandler}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a value between 0 and 100.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  minWidth: '15rem',
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Default Schedule</strong>
                <p className="pt-2 text-muted">
                  Manage scheduling rules and automatic shift assignments
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                {editedShifts.map((editedShift, index) => (
                  <div key={`edited-${index}`} className="pb-3">
                    <div
                      className="border rounded mb-3"
                      style={{ padding: '2.25rem' }}
                    >
                      <div className="row">
                        <div className="col-sm-4">
                          <strong>Shift Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={editedShift.name || ''}
                            maxLength={255}
                            onChange={(e) => editedShiftNameHandler(e, index)}
                          />
                        </div>
                        <div className="col-sm-4">
                          <strong>Start Time</strong>
                          <input
                            type="time"
                            disabled
                            className="form-control mt-3"
                            value={editedShift.start_time}
                          />
                        </div>
                        <div className="col-sm-4">
                          <strong>End Time</strong>
                          <input
                            type="time"
                            disabled
                            className="form-control mt-3"
                            value={editedShift.end_time}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {newShifts.map((shift, index) => (
                  <div key={`new-${index}`} className="pb-3">
                    <div className="d-flex justify-content-end mb-3">
                      <strong
                        style={{ cursor: 'pointer' }}
                        className="text-danger"
                        onClick={() => removeShift(index)}
                      >
                        <i className="fas fa-trash"></i>&nbsp;&nbsp;&nbsp;Remove
                      </strong>
                    </div>
                    <div
                      className="border rounded mb-3"
                      style={{ padding: '2.25rem' }}
                    >
                      <div className="row">
                        <div className="col-sm-4">
                          <strong>Shift Name</strong>
                          <input
                            required
                            type="text"
                            className="form-control mt-3"
                            value={shift.name}
                            maxLength={255}
                            onChange={(e) => newShiftNameHandler(e, index)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter shift name.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-sm-4">
                          <strong>Start Time</strong>
                          <input
                            required
                            type="time"
                            className="form-control mt-3"
                            value={shift.start_time}
                            onChange={(e) => newShiftStartTimeHandler(e, index)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter shift name.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-sm-4">
                          <strong>End Time</strong>
                          <input
                            required
                            type="time"
                            className="form-control mt-3"
                            value={shift.end_time}
                            onChange={(e) => newShiftEndTimeHandler(e, index)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter shift name.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => addShifts()}
                  className="border rounded"
                  style={{
                    paddingLeft: '2.25rem',
                    paddingRight: '2.25rem',
                    paddingTop: '1.5rem',
                    paddingBottom: '1.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <i className="fas fa-plus"></i>&nbsp;&nbsp;&nbsp;
                  <strong>Add New Shift</strong>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                backgroundColor: '#f3f3f3',
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingLeft: '3rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-between"
            >
              <button
                type="button"
                onClick={deactivateSiteHandler}
                className="btn btn-outline-danger align-items-start adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Deactivate Site
              </button>
              <div className="d-flex">
                <button
                  type="button"
                  onClick={discardHandler}
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default EditSite;
